export const PARTNER_REGISTER_REQUEST = "PARTNER_REGISTER_REQUEST";
export const PARTNER_REGISTER_SUCCESS = "PARTNER_REGISTER_SUCCESS";
export const PARTNER_REGISTER_FAIL = "PARTNER_REGISTER_FAIL";
